import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {ProjectStatus} from '../../project-misc/data/project/statuses/project-status';

@JsonObject('model.project.Project')
export class Cabinet extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(Number, 'cabinetId')
    cabinetId?: number;

    @JsonProperty(Number, 'quantity')
    quantity?: number;

    @JsonProperty(Number, 'roomId')
    roomId?: number;

    @JsonProperty(String, 'roomName')
    roomName?: string;

    @JsonProperty(String, 'notes')
    notes?: string;

    @JsonProperty(String, 'cabinetName')
    cabinetName?: string;

    @JsonProperty(String, 'widthFraction')
    widthFraction?: string;

    @JsonProperty(String, 'heightFraction')
    heightFraction?: string;

    showName?: string;

    @JsonProperty(ProjectStatus, 'status')
    status?: ProjectStatus;

    @JsonProperty(String, 'description')
    description?: string;

    @JsonProperty(Number, 'width')
    width?: number;

    @JsonProperty(Number, 'height')
    height?: number;

    @JsonProperty(Number, 'depth')
    depth?: number;

    @JsonProperty(Number, 'page')
    page?: number;

    @JsonProperty(Boolean, 'assemblyReady')
    assemblyReady?: boolean;

    @JsonProperty(Boolean, 'qualityControlReady')
    qualityControlReady?: boolean;

    @JsonProperty(Boolean, 'jobDeliveryReady')
    jobDeliveryReady?: boolean;

    @JsonProperty(Boolean, 'createdManually')
    createdManually?: boolean;

    @JsonProperty(Boolean, 'hardwareGroup')
    hardwareGroup?: boolean;
}
